import { Routes } from '@angular/router';
import { LockscreenPage } from './lockscreen.component';

export const lockscreen: Routes = [
  {
    path: 'lockscreen',
    component: LockscreenPage,
    title: 'Sesión bloqueada',
  },
];
